import { isDeferAggregateIndexBackfillEnabled } from './bootFeatureFlags';
import { scheduleStartupIdle } from './scheduleStartupIdle';
import { markBootGate } from '../telemetry/bootTelemetry';

/**
 * Runs aggregate index backfill immediately or defers to idle (Phase 3).
 */
export function scheduleAggregateIndexBackfill(runBackfill) {
  if (isDeferAggregateIndexBackfillEnabled()) {
    markBootGate('aggregate_index_backfill_deferred');
    scheduleStartupIdle(() => void runBackfill(), 4000);
    return;
  }
  void runBackfill();
}
